
import React from 'react';

interface GameLoadingProps {
  title: string;
}

const GameLoading: React.FC<GameLoadingProps> = ({ title }) => {
  return (
    <div 
      className="absolute inset-0 bg-white bg-opacity-80 flex items-center justify-center z-10"
      role="alert"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="text-center">
        <div 
          className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-coral border-r-transparent mb-4"
          aria-hidden="true"
        ></div>
        <p id="loading-status">Loading {title}...</p>
      </div>
    </div>
  );
};

export default GameLoading;
